import { GlTabs, GlTab, GlBadge } from '@gitlab/ui';
import { numberToMetricPrefix } from '~/lib/utils/number_utils';
import { formatNumber } from '~/locale';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'IssuableTabs',
    components: {
        GlTabs,
        GlTab,
        GlBadge
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        tabs: {
            type: Array,
            required: true
        },
        tabCounts: {
            type: Object,
            required: false,
            default: null
        },
        currentTab: {
            type: String,
            required: true
        },
        truncateCounts: {
            type: Boolean,
            required: false,
            default: false
        },
        maxCount: {
            type: Number,
            required: false,
            default: null
        }
    },
    emits: [
        'click'
    ],
    methods: {
        isTabActive (tabName) {
            return tabName === this.currentTab;
        },
        isTabCountNumeric (tab) {
            return Number.isInteger(this.tabCounts[tab.name]);
        },
        formatNumber (count) {
            if (this.maxCount) {
                return count > this.maxCount ? `${this.maxCount}+` : count;
            }
            return this.truncateCounts ? numberToMetricPrefix(count) : formatNumber(count);
        }
    }
};
